import { render, staticRenderFns } from "./CreateOrderBasket.vue?vue&type=template&id=ab12dd06"
import script from "./CreateOrderBasket.vue?vue&type=script&lang=js"
export * from "./CreateOrderBasket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports